import {z} from 'zod';

export const ChallengeParticipationStatusSchema = z.enum(['in-progress', 'completed']);
export type ChallengeParticipationStatus = z.infer<typeof ChallengeParticipationStatusSchema>;
